/* global axios */
import ApiClient from '../ApiClient';

// Panel del grupo de WhatsApp QR (F3a). Backend: Api::V1::Accounts::Masifi::WhatsappQrGroupsController, por display_id.
class MasifiWhatsappQrGroupsAPI extends ApiClient {
  constructor() {
    super('masifi/whatsapp_qr_groups', { accountScoped: true });
  }

  get(conversationId) {
    return axios.get(`${this.url}/${conversationId}`);
  }

  members(conversationId, { page = 1, q = '' } = {}) {
    return axios.get(`${this.url}/${conversationId}/members`, {
      params: { page, q: q || undefined },
    });
  }

  // E2E fix batch 1: los grupos de la PERSONA de esta conversación (panel del contacto).
  contactGroups(conversationId, { page = 1 } = {}) {
    return axios.get(`${this.url}/${conversationId}/contact_groups`, {
      params: { page },
    });
  }

  update(conversationId, { crmMode, handlingInboxId } = {}) {
    const body = { crm_mode: crmMode, handling_inbox_id: handlingInboxId };
    Object.keys(body).forEach(
      key => body[key] === undefined && delete body[key]
    );
    return axios.patch(`${this.url}/${conversationId}`, body);
  }

  sync(conversationId) {
    return axios.post(`${this.url}/${conversationId}/sync`);
  }

  markTeam(conversationId, memberId) {
    return axios.post(`${this.url}/${conversationId}/team_contacts`, {
      member_id: memberId,
    });
  }

  unmarkTeam(conversationId, memberId) {
    return axios.delete(
      `${this.url}/${conversationId}/team_contacts/${memberId}`
    );
  }
}

export default new MasifiWhatsappQrGroupsAPI();
